import React, { ReactNode } from "react";

export const HomeChargingSvg: ReactNode = (
  <g>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3381 1.85903C12.9706 1.52735 12.4932 1.34375 11.9981 1.34375C11.5031 1.34375 11.0256 1.52735 10.6581 1.85903L1.32812 10.259L2.66813 11.739L3.99813 10.549V21.999H19.9981V10.549L21.3281 11.739L22.6681 10.259L13.3381 1.85903ZM17.9981 19.999H12.9981V15.859C13.8546 15.6379 14.6136 15.1391 15.1564 14.4407C15.6993 13.7422 15.9953 12.8836 15.9981 11.999H14.9981V8.99903H12.9981V11.999H10.9981V8.99903H8.99813V11.999H7.99813C8.001 12.8836 8.297 13.7422 8.83981 14.4407C9.38263 15.1391 10.1416 15.6379 10.9981 15.859V19.999H5.99813V8.74903L11.9981 3.33903L17.9981 8.74903V19.999Z"
        fill="#242D3D"
      />
    </svg>
  </g>
);
